import { h } from "@stencil/core";
import { DATE_ISO } from "./constants";
const CalendarDay = ({ baseClass, date, isDisabled, isInactive, isHighlighted, isSelected, isToday, onSelectDay, onHoverDay }) => {
    const handleClickButton = isDisabled || onSelectDay === undefined ? undefined : () => onSelectDay(date);
    const handleHoverButton = isDisabled || onHoverDay === undefined ? undefined : () => onHoverDay(date);
    const className = `${baseClass}__calendar-day`;
    return (h("span", {
        // @ts-expect-error Check for typing
        class: {
            [className]: true,
            [`${className}--disabled`]: isDisabled,
            [`${className}--highlighted`]: isHighlighted,
            [`${className}--inactive`]: isInactive,
            [`${className}--selected`]: isSelected,
            [`${className}--today`]: isToday
        }
    }, h("button", { "aria-selected": !!isSelected, class: `${className}-btn`, "data-day": date.format(DATE_ISO), onClick: handleClickButton, onMouseEnter: handleHoverButton, type: "button" }, date.format("D"))));
};
export default CalendarDay;
//# sourceMappingURL=calendar-day.js.map
